export default "__VITE_ASSET__BKMf2pow__"